import { apiClient } from "./api";

export interface KnowledgeChunk {
  id: string;
  content: string;
  similarity: number;
}

export interface KnowledgeQueryResponse {
  chunks: KnowledgeChunk[];
}

export interface KnowledgeUploadResponse {
  status: string;
  document_id: string;
  chunks: number;
}

export interface KnowledgeDocument {
  id: string;
  name: string;
  storage_path?: string;
  created_at?: string;
  chunk_count: number;
}

export async function listKnowledgeDocuments(): Promise<KnowledgeDocument[]> {
  const response = await apiClient.get("/knowledge/documents");
  return response.data;
}

export async function deleteKnowledgeDocument(documentId: string): Promise<void> {
  await apiClient.delete(`/knowledge/documents/${documentId}`);
}

export async function uploadKnowledgeFile(file: File): Promise<KnowledgeUploadResponse> {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post("/knowledge/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export async function queryKnowledge(question: string, topK = 5): Promise<KnowledgeQueryResponse> {
  const response = await apiClient.post("/knowledge/query", {
    question,
    top_k: topK,
  });
  return response.data;
}
